import { useState, useEffect, useCallback } from "react";

import { api_without_cancellation } from "../../../../api/api";

const useCaseTypes = (currentFilter) => {
  const [allFirmCaseTypes, setAllFirmCaseTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCaseTypes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const config = currentFilter
        ? {
            params: {
              [currentFilter.type]: currentFilter.name || "",
            },
          }
        : {};

      const response = await api_without_cancellation.get(
        "/api/navigator/navigator_case_types/",
        config
      );
      // const response = await api_without_cancellation.get("/api/navigator/navigator_case_types/");
      setAllFirmCaseTypes(response.data.all_firm_cases || []);
    } catch (err) {
      console.error("Failed to fetch case types:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCaseTypes();
  }, [fetchCaseTypes, currentFilter]);

  return {
    allFirmCaseTypes,
    loading,
    error,
    refetch: fetchCaseTypes,
  };
};

export default useCaseTypes;
